export const FORM_TEXTS = {
  TITLE: "GCTO Service Provider Portal",
  CREATE_RECORD: "Create New Record",
  UPDATE_RECORD: "Update Existing Record",
  SEARCH_RECORD: "Search Existing Record",
  PRIMARY_CONTACT_DETAILS: "Primary Contact Details",
  SECONDARY_CONTACT_DETAILS: "Secondary Contact Details",
  CREATE_RECORD_MESSAGE: `If you are a new service provider registering with us for the first time, please
click the 'Create New Record' button to start the process.`,
  UPDATE_RECORD_MESSAGE: `Already registered? Click 'Update Existing Record' to update your details. Please start by entering your company’s name, Request ID, and either primary or secondary contact email associated with your company’s profile.`,
  UPDATE_RECORD_MESSAGE_NOTE: `Note: The Request ID is sent to the primary email address (and/or secondary email address) entered following creation of the original company profile.`,
  UPDATE_RECORD_MESSAGE_INTERNAL: `Click 'Search Existing Record' to search service provider details available in the system by entering service provider name.`,
  MSD_EMPLOYEE: "MSD Employee",
  HELP_TEXT: "Help",
  ADMIN_TEXT: "Admin",
};

export const FORM_FIELDS = {
  SERVICE_PROVIDER_NAME: "Service Provider Name",
  SERVICE_PROVIDER_URL: "Service Provider URL",
  ADDRESS: "Address",
  COUNTRY: "Country",
  SERVICES_PROVIDED: "Services Provided",
  SERVICE_COUNTRIES: "Service Countries",
  REQUEST_ID: "Request ID",
  CONTACT_NAME: "Name",
  CONTACT_EMAIL: "Email",
  CONTACT_PHONE: "Phone Number",
  CONTACT_TITLE: "Title",
  PRIMARY_CONTACT_EMAIL: "Primary Contact Email",
  SECONDARY_CONTACT_EMAIL: "Secondary Contact Email",
  BTN_CANCEL: "Cancel",
  BTN_SAVE: "Save",
  BTN_ADD: "Add",
  BTN_DELETE: "Delete",
  BTN_SEARCH: "Search",
  BTN_SUBMIT: "Submit",
};

export const FORM_VALIDATION = {
  SERVICE_PROVIDER_NAME: "Service Provider Name is required",
  SERVICE_PROVIDER_URL: "Service Provider URL is required",
  INVALID_SERVICE_PROVIDER_URL: "Please enter valid URL",
  SERVICES_PROVIDED: "Services Provided is required",
  SERVICE_COUNTRIES: "Service Countries is required",
  REQUEST_ID: "Request ID is required",
  CONTACT_NAME: "Name is required",
  CONTACT_EMAIL: "Email is required",
  CONTACT_TITLE: "Title is required",
  INVALID_CONTACT_EMAIL: "Please enter valid email",
  BUSINESS_EMAIL: "Please use a business email address.",
  CONTACT_PHONE: "Phone is required",
  INVALID_CONTACT_PHONE: "Please enter valid phone number",
};

export const ADMIN_TEXTS = {
  MODIFY_ADMIN: "Add/Update Admin",
  ADD_SERVICE_OFFERINGS: "Add Service Offering",
  EXPORT_VENDOR_DATA: "Export Complete Service Provider Data",
  ADD_NEW: "Add New",
  CONFIRM_DELETE_ADMIN: "Confirm delete Admin",
  CONFIRM_DELETE_SERVICE_OFFERINGS: "Confirm delete Service Offerings",
  DELETE_MESSAGE:
    "Are you sure you want to delete? This action cannot be undone",
  SERVICE_OFFERINGS: "Service Offerings",
};
